import {Component, Injector} from '@angular/core';
import {CouponState, Store as CouponStore} from './state/store';
import {Coupon} from './state/model';
import {CouponService as CouponService} from './state/service';
import {EntityDetailComponent} from '../../components/entity-detail/component';
import {FormBuilder} from '@angular/forms';
import {CouponQuery} from './state/query';

@Component({
  templateUrl: '../../components/entity-detail/component.html',
  styleUrls: ['../../components/entity-detail/component.scss']
})
export class CouponDetailComponent extends EntityDetailComponent<Coupon, CouponState, CouponStore> {

  constructor(
    public injector: Injector,
    service: CouponService,
    protected query: CouponQuery,
    protected formBuilder: FormBuilder) {
    super(injector, service, query);
  }
}
